import * as _ from "lodash";

export class Image {
	title;
	description;
	caption;
	media;
	dominantColor;
	alt;
	sizes;
	
	constructor (object)
	{
		// this.title = object.title.rendered || null;
		this.description = object.description.rendered || null;
		this.caption = object.caption.rendered || null;
		this.alt = object.alt_text || null;
		this.media = object.media_type || null;
		this.sizes = {
			"original": this.getUrl(object, ["source_url", "full_url"]),
			"lazy": this.getUrl(object, ["media_details.sizes.lazy.source_url", "sizes.lazy.file"]),
			"thumbnail": this.getUrl(object, ["media_details.sizes.thumbnail.source_url", "sizes.thumbnail.file"]),
			"small": this.getUrl(object, ["media_details.sizes.small.source_url", "sizes.small.file"]),
			"medium": this.getUrl(object, ["media_details.sizes.medium.source_url", "sizes.medium.file"]),
			"large": this.getUrl(object, ["media_details.sizes.large.source_url", "sizes.large.file", ]),
			"huge": this.getUrl(object, ["media_details.sizes.huge.source_url", "sizes.huge.file"]),
		};
	}

	getUrl(object, path) {

		let url;
		let i = 0;

		while (!url && i < path.length)
		{
			if (_.get(object, path[i], null))
				url = _.get(object, path[i]);
			else
				i++;
		}
		
		if (!url)
			return null;
		else if (url.indexOf("http") !== -1) {
			return url;
		} else {
			let array = object.full_url.split("/");
			array[array.length-1] = url;
			return array.join("/");
		}
	}
}


// WEBPACK FOOTER //
// ./src/components/blocks/image/image.class.js